import {
  CloudFilled,
  DeleteOutlined,
  EditOutlined,
  EyeFilled,
  LockFilled
} from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import React from "react";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { IUser } from "../../../user/model/User";
import { CaseLawDocumentStatus } from "../../common/Constants";
import { TCaseLawDocumentPresentationModel } from "../../presenter/model/CaseLawDocumentPresentationModel";

export interface Props {
  user?: IUser;
  translate: TTranslate;
  caseLawDocument: TCaseLawDocumentPresentationModel;
  onEditClick(id: number): void;
  onArchiveClick(id: number): void;
  onPublishClick(id: number): void;
  onUndoClick(id: number): void;
  deleteCaseLawDocument(): void;
}

const CaseLawDocumentToolbar = ({
  user,
  translate,
  caseLawDocument,
  onEditClick,
  onArchiveClick,
  onPublishClick,
  onUndoClick,
  deleteCaseLawDocument
}: Props) => {
  return (
    <div style={{ marginTop: 24, marginLeft: 24 }}>
      {(user?.isAdmin() || user?.isOperator()) &&
        caseLawDocument.status !== CaseLawDocumentStatus.ARCHIVED &&
        caseLawDocument.status !== CaseLawDocumentStatus.INVALIDATED && (
          <Button
            value=""
            shape={"round"}
            type="link"
            onClick={() => onEditClick(caseLawDocument.id)}
          >
            <EditOutlined style={{ marginRight: 5 }} />{" "}
            {translate("editors.case_law_documents.edit")}
          </Button>
        )}
      <br />
      {(user?.isAdmin() || user?.isOperator()) &&
        caseLawDocument.status !== CaseLawDocumentStatus.ARCHIVED &&
        caseLawDocument.status !== CaseLawDocumentStatus.INVALIDATED && (
          <Popconfirm
            title={translate("editors.case_law_documents.delete_confirm")}
            onConfirm={() => deleteCaseLawDocument()}
            okText={translate("editors.case_law_documents.confirm")}
            cancelText={translate("editors.case_law_documents.cancel")}
          >
            <Button value="" type="link" shape={"round"}>
              <DeleteOutlined style={{ marginRight: 5 }} />{" "}
              {translate("editors.case_law_documents.delete")}
            </Button>
          </Popconfirm>
        )}
      <br />
      {(user?.isAdmin() || user?.isOperator()) &&
        caseLawDocument.status !== CaseLawDocumentStatus.ARCHIVED &&
        caseLawDocument.status !== CaseLawDocumentStatus.INVALIDATED && (
          <Popconfirm
            title={translate("editors.case_law_documents.archive_confirm")}
            onConfirm={() => onArchiveClick(caseLawDocument.id)}
            okText={translate("editors.case_law_documents.confirm")}
            cancelText={translate("editors.case_law_documents.cancel")}
          >
            <Button value="" type="link" shape={"round"}>
              <LockFilled style={{ marginRight: 5 }} />{" "}
              {translate("editors.case_law_documents.archive")}
            </Button>
          </Popconfirm>
        )}
      <br />
      {(user?.isAdmin() || user?.isOperator()) && (
        <>
          {caseLawDocument.status === CaseLawDocumentStatus.VERIFIED && (
            <Button
              shape={"round"}
              type={"link"}
              onClick={() => onPublishClick(caseLawDocument.id)}
            >
              <EyeFilled style={{ marginRight: 5 }} />{" "}
              {translate("editors.case_law_documents.publish")}
            </Button>
          )}
          <br />
          {caseLawDocument.status === CaseLawDocumentStatus.INVALIDATED && (
            <Button
              shape={"round"}
              type={"link"}
              onClick={() => onPublishClick(caseLawDocument.id)}
            >
              <EyeFilled style={{ marginRight: 5 }} />{" "}
              {translate("editors.case_law_documents.revalidate_and_publish")}
            </Button>
          )}
          <br />
          {caseLawDocument.status === CaseLawDocumentStatus.PUBLISHED && (
            <Button
              className={"case-law-document-revert-status-btn"}
              shape={"round"}
              type={"link"}
              onClick={() => onUndoClick(caseLawDocument.id)}
            >
              <CloudFilled style={{ marginRight: 5 }} />{" "}
              {translate("editors.case_law_documents.revert_status")}
            </Button>
          )}
          <br />
        </>
      )}
    </div>
  );
};

export default CaseLawDocumentToolbar;
